import { VIEW_ADMINISTRATIVE } from "./constants";
import { mergeEntity } from "./model";

export const createInitialState = () => ({
  viewMode: VIEW_ADMINISTRATIVE,

  data: {
    departments: [],
    arrondissements: [],
    constituencies: [],
    communes: [],
    sections: [],
    votingCenters: [],
  },

  selection: {
    type: "",
    item: null,
    department: null,
    arrondissement: null,
    constituency: null,
    commune: null,
    section: null,
    votingCenter: null,
  },

  expanded: {
    department: null,
    arrondissement: null,
    constituency: null,
    commune: null,
    section: null,
  },

  ui: {
    loading: false,
    error: "",
  },

  contextMenu: null,

  dialog: {
    open: false,
    mode: "create",
    entity: "",
    parent: null,
    parentType: "",
    initialValue: null,
    saving: false,
    error: "",
  },
});

export const mutateState = (setState, mutator) => {
  setState((prev) => {
    const next = {
      ...prev,
      data: { ...prev.data },
      selection: { ...prev.selection },
      expanded: { ...prev.expanded },
      ui: { ...prev.ui },
      dialog: { ...prev.dialog },
      contextMenu: prev.contextMenu ? { ...prev.contextMenu } : null,
    };

    mutator(next, prev);

    return next;
  });
};

export const setLoading = (setState, loading) => {
  mutateState(setState, (state) => {
    state.ui.loading = loading;
  });
};

export const setError = (setState, error) => {
  mutateState(setState, (state) => {
    state.ui.error = error || "";
  });
};

export const setDialogSaving = (setState, saving) => {
  mutateState(setState, (state) => {
    state.dialog.saving = saving;
  });
};

export const setDialogError = (setState, error) => {
  mutateState(setState, (state) => {
    state.dialog.error = error || "";
  });
};

export const setRootLists = (setState, roots) => {
  mutateState(setState, (state) => {
    state.data.departments = roots.departments || [];
    state.data.constituencies = roots.constituencies || [];
    state.data.arrondissements = roots.arrondissements || [];
  });
};

export const setArrondissements = (setState, arrondissements) => {
  mutateState(setState, (state) => {
    state.data.arrondissements = arrondissements || [];
  });
};

export const setCommunes = (setState, communes) => {
  mutateState(setState, (state) => {
    state.data.communes = communes || [];
  });
};

export const setSections = (setState, sections) => {
  mutateState(setState, (state) => {
    state.data.sections = sections || [];
  });
};

export const setVotingCenters = (setState, votingCenters) => {
  mutateState(setState, (state) => {
    state.data.votingCenters = votingCenters || [];
  });
};

export const clearSelectionBelowRoot = (setState) => {
  mutateState(setState, (state) => {
    state.selection.department = null;
    state.selection.arrondissement = null;
    state.selection.constituency = null;
    state.selection.commune = null;
    state.selection.section = null;
    state.selection.votingCenter = null;
    state.selection.type = "";
    state.selection.item = null;

    state.data.arrondissements = [];
    state.data.communes = [];
    state.data.sections = [];
    state.data.votingCenters = [];

    state.expanded = {
      department: null,
      arrondissement: null,
      constituency: null,
      commune: null,
      section: null,
    };
  });
};

export const setViewMode = (setState, viewMode) => {
  mutateState(setState, (state) => {
    state.viewMode = viewMode;
  });
};

export const selectEntity = (setState, type, item) => {
  mutateState(setState, (state) => {
    state.selection.type = type;
    state.selection.item = item;

    if (type === "department") {
      state.selection.department = item;
      state.selection.arrondissement = null;
      state.selection.commune = null;
      state.selection.section = null;
      state.selection.votingCenter = null;
      state.data.communes = [];
      state.data.sections = [];
      state.data.votingCenters = [];
    }

    if (type === "arrondissement") {
      state.selection.arrondissement = item;
      state.selection.commune = null;
      state.selection.section = null;
      state.selection.votingCenter = null;
      state.data.communes = [];
      state.data.sections = [];
      state.data.votingCenters = [];
    }

    if (type === "constituency") {
      state.selection.constituency = item;
      state.selection.commune = null;
      state.selection.section = null;
      state.selection.votingCenter = null;
      state.data.communes = [];
      state.data.sections = [];
      state.data.votingCenters = [];
    }

    if (type === "commune") {
      state.selection.commune = item;
      state.selection.section = null;
      state.selection.votingCenter = null;
      state.data.sections = [];
      state.data.votingCenters = [];
    }

    if (type === "section") {
      state.selection.section = item;
      state.selection.votingCenter = null;
      state.data.votingCenters = [];
    }

    if (type === "voting-center") {
      state.selection.votingCenter = item;
    }
  });
};

export const toggleExpanded = (setState, type, gid) => {
  mutateState(setState, (state, prev) => {
    if (type === "department") {
      state.expanded.department = prev.expanded.department === gid ? null : gid;
      state.expanded.arrondissement = null;
      state.expanded.commune = null;
      state.expanded.section = null;
      return;
    }

    if (type === "arrondissement") {
      state.expanded.arrondissement = prev.expanded.arrondissement === gid ? null : gid;
      state.expanded.commune = null;
      state.expanded.section = null;
      return;
    }

    if (type === "constituency") {
      state.expanded.department = prev.expanded.department;
      state.expanded.arrondissement = null;
      state.expanded.constituency = prev.expanded.constituency === gid ? null : gid;
      state.expanded.commune = null;
      state.expanded.section = null;
      return;
    }

    if (type === "commune") {
      state.expanded.commune = prev.expanded.commune === gid ? null : gid;
      state.expanded.section = null;
      return;
    }

    if (type === "section") {
      state.expanded.section = prev.expanded.section === gid ? null : gid;
    }
  });
};

export const openContextMenu = (setState, event, type, item) => {
  mutateState(setState, (state) => {
    state.contextMenu = {
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
      type,
      item,
    };

    state.selection.type = type;
    state.selection.item = item;
  });
};

export const closeContextMenu = (setState) => {
  mutateState(setState, (state) => {
    state.contextMenu = null;
  });
};

export const openDialog = (setState, mode, entity, parent = null, parentType = "", initialValue = null) => {
  mutateState(setState, (state) => {
    state.dialog = {
      open: true,
      mode,
      entity,
      parent,
      parentType,
      initialValue,
      saving: false,
      error: "",
    };

    state.contextMenu = null;
  });
};

export const closeDialog = (setState) => {
  mutateState(setState, (state) => {
    state.dialog.open = false;
  });
};

export const clearDeletedSelection = (setState, type) => {
  mutateState(setState, (state) => {
    if (type === "voting-center") {
      state.selection.votingCenter = null;
    }

    if (type === "section") {
      state.selection.section = null;
      state.data.votingCenters = [];
    }

    if (type === "commune") {
      state.selection.commune = null;
      state.data.sections = [];
      state.data.votingCenters = [];
    }

    if (type === "arrondissement") {
      state.selection.arrondissement = null;
      state.data.communes = [];
      state.data.sections = [];
      state.data.votingCenters = [];
    }

    if (type === "department") {
      state.selection.department = null;
      state.data.arrondissements = [];
      state.data.communes = [];
      state.data.sections = [];
      state.data.votingCenters = [];
    }

    if (type === "constituency") {
      state.selection.constituency = null;
      state.data.communes = [];
      state.data.sections = [];
      state.data.votingCenters = [];
    }

    state.selection.type = "";
    state.selection.item = null;
  });
};

export const mergeSavedEntity = (setState, entity, item) => {
  if (!item?.gid) {
    return;
  }

  mutateState(setState, (state) => {
    const keys = {
      department: "departments",
      arrondissement: "arrondissements",
      constituency: "constituencies",
      commune: "communes",
      section: "sections",
      "voting-center": "votingCenters",
    };

    const selectionKeys = {
      department: "department",
      arrondissement: "arrondissement",
      constituency: "constituency",
      commune: "commune",
      section: "section",
      "voting-center": "votingCenter",
    };

    const dataKey = keys[entity];
    const selectionKey = selectionKeys[entity];

    if (dataKey) {
      state.data[dataKey] = state.data[dataKey].map((row) => mergeEntity(row, item));
    }

    if (selectionKey) {
      state.selection[selectionKey] = mergeEntity(state.selection[selectionKey], item);
    }

    state.selection.item = mergeEntity(state.selection.item, item);
  });
};
